import axios from 'axios';
import { HIDE_ERROR_AFTER_MS } from '@/Core/utilities/index';

export const INTEGRATION_STATUS = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
};
const leadClaimAction = 'claim';
const leadUnclaimAction = 'unclaim';

export default {
  namespaced: true,
  state: {
    isLeadClaimed: true,
    loading: false,
    qualifyConversationError: false,
    qualifyConversationSuccess: false,
    qualifyConversationMessage: '',
    hasError: false,
    error: {
      service: null,
      message: null,
    },
    qualifyContactLead: null,
    integrationStatus: INTEGRATION_STATUS.DISCONNECTED,
    qualifyCustomer: null,
    loaded: false,
  },
  getters: {
    isIntegrationConnected: state => {
      return state.integrationStatus === INTEGRATION_STATUS.CONNECTED;
    },
    isSetPreference: state => {
      return state.qualifyCustomer && state.qualifyCustomer.concierge_notes !== '';
    },
    getPreference: state => {
      return state.qualifyCustomer && state.qualifyCustomer.concierge_notes;
    },
  },
  mutations: {
    setIsLeadClaimed(state, isClaimed) {
      state.isLeadClaimed = !!isClaimed;
    },
    setError(state, error) {
      state.loading = false;
      state.error = error;
      state.qualifyConversationError = true;
      state.hasError = true;
    },
    clearError(state) {
      state.qualifyConversationError = false;
      state.error = {
        service: null,
        message: null,
      };
      state.hasError = false;
    },
    isLoading(state) {
      state.loading = true;
    },
    success(state, message) {
      state.qualifyConversationError = false;
      state.qualifyConversationMessage = message;
      state.qualifyConversationSuccess = true;
      state.loading = false;
      state.error = {
        service: null,
        message: null,
      };
    },
    clearMessage(state) {
      state.qualifyConversationError = false;
      state.qualifyConversationMessage = '';
      state.qualifyConversationSuccess = false;
      state.loading = false;
      state.error = {
        service: null,
        message: null,
      };
      state.hasError = false;
    },
    setQualifyContactLead(state, qualify) {
      state.qualifyContactLead = qualify;
    },
    setIntegrationStatus(state, status) {
      state.integrationStatus = status;
    },
    setQualifyCustomer(state, qualify) {
      state.qualifyCustomer = qualify;
    },
    setLoaded(state, value) {
      state.loaded = value;
    }
  },
  actions: {
    async addNoteQualify({ state, commit }, note) {
      try {
        commit('isLoading');
        const { lead_id } = state.qualifyContactLead;
        const response = await axios.post(
          `${process.env.VUE_APP_INTEGRATIONS}/qualify/leads/${lead_id}/note`,
          {
            notes: note,
          },
        );
        commit('success', 'Note added');
      } catch (error) {
        commit('setError', {
          service: 'Note qualify',
          message: error.message,
        });
        setTimeout(() => {
          commit('clearError');
        }, HIDE_ERROR_AFTER_MS);
      }
      setTimeout(() => {
        commit('clearMessage');
      }, HIDE_ERROR_AFTER_MS);
    },
    async stopQualifyConversation({ state, commit }) {
      const contactId = state.qualifyContactLead.contact_id;
      try {
        commit('isLoading');
        await axios.put(`${process.env.VUE_APP_INTEGRATIONS}/qualify/manage-lead-claim`, {
          action: leadClaimAction,
          contact_id: contactId,
        });
        commit('success', 'Qualifier stopped');
        commit('setIsLeadClaimed', true);
      } catch (error) {
        commit('setError', {
          service: 'Qualify conversation',
          message: error.message,
        });
        setTimeout(() => {
          commit('clearError');
        }, HIDE_ERROR_AFTER_MS);
      }
      setTimeout(() => {
        commit('clearMessage');
      }, HIDE_ERROR_AFTER_MS);
    },
    async startQualifyConversation({ state, commit }, comment) {
      const { contact_id: contactId, lead_id: leadId } = state.qualifyContactLead;
      try {
        commit('isLoading');
        await axios.put(`${process.env.VUE_APP_INTEGRATIONS}/qualify/manage-lead-claim`, {
          contact_id: contactId,
          action: leadUnclaimAction,
          notes: comment,
        });
        commit('success', 'Qualifier started');
        commit('setIsLeadClaimed', false);
      } catch (error) {
        commit('setError', {
          service: 'Qualify conversation',
          message: error.message,
        });
        setTimeout(() => {
          commit('clearError');
        }, HIDE_ERROR_AFTER_MS);
      }
      setTimeout(() => {
        commit('clearMessage');
      }, HIDE_ERROR_AFTER_MS);
    },
    async loadContactQualifyStatus({ commit, state }, contactId) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_INTEGRATIONS}/qualify/lead`, {
          params: {
            contact_id: contactId,
          },
        });
        commit('setQualifyContactLead', response.data);
        commit(
          'setIsLeadClaimed',
          response.data && response.data.claimed && response.data.claimed.Bool,
        );
      } catch (error) {
        commit('setQualifyContactLead', null);
      }
    },
    async getIntegrationStatus({ commit, rootState, dispatch }, forceUpdate = false) {
      try {
        if (!rootState.integrations.loaded || forceUpdate) {
          await dispatch('integrations/getIntegrations', null, { root: true });
        }
        let integrations = rootState.integrations.integrations;
        const integration = integrations.find(n => n.name === 'Qualify');
        if (integration) {
          return commit('setIntegrationStatus', integration.status);
        }
      } catch (error) {
        commit('setIntegrationStatus', error);
      } finally {
        commit('setLoaded', true);
      }
    },
    async loadQualifyCustomer({ state, commit }) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_INTEGRATIONS}/qualify/customer`);
        commit('setQualifyCustomer', response.data);
      } catch (error) {
        commit('setQualifyCustomer', null);
      }
    },
    async setPreferencesNote({ state, commit }, note) {
      try {
        commit('isLoading');
        const response = await axios.put(
          `${process.env.VUE_APP_INTEGRATIONS}/qualify/customer`,
          {
            concierge_notes: note,
          },
        );
        commit('success', 'Note added');
      } catch (error) {
        commit('setError', {
          service: 'Qualify',
          message: error.message,
        });
      }
    },
    clearError({ commit }) {
      commit('clearError');
    }
  },
};
